/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_1Aliases {
  AUTOCOMPLETE_PATIENT_INFO = 'autocomplete-patient-info',
  AUTOCOMPLETE_PRIOR_LOCATION = 'autocomplete-prior-location',
  AVATAR = 'avatar',
  FETCH_PATIENT_INFO = 'fetch-patient-info',
  FETCH_PRIOR_LOCATION = 'fetch-prior-location',
  FIELD_INSURANCE = 'field-insurance',
  FIELD_PATIENT_INFO = 'field-patient-info',
  FIELD_PRIOR_LOCATION = 'field-prior-location',
  FORM_INSURANCE = 'form-insurance',
  FORM_PATIENT_INFO = 'form-patient-info',
  HEALTH_INSURANCE_CARD = 'health-insurance-card',
  LAYOUT_PATIENT_INFO = 'layout-patient-info',
  LOADER_ELIGIBILITY = 'loader-eligibility',
  MAPPER_PATIENT_INFO = 'mapper-patient-info',
  MAPPER_PRIOR_LOCATION = 'mapper-prior-location',
  PANEL_INSURANCE = 'panel-insurance',
  PANEL_LOADER_ELIGIBILITY = 'panel-loader-eligibility',
  PANEL_PATIENT_INFO = 'panel-patient-info',
  PANEL_PRIOR_LOCATION = 'panel-prior-location',
  SEGMENTED_CONTROL_INSURANCE = 'segmented-control-insurance',
  TEXT_PATIENT_INFO_INSTRUCTION = 'text-patient-info-instruction',
  TEXT_PATIENT_SELECT_INSURANCE = 'text-patient-select-insurance',
  TEXT_PRIOR_LOCATION = 'text-prior-location',
}
export { PseudonymAppointmentsStep_1Aliases };
